//引入接口文档
import req from '@/utils/req.js'

// -----------服务类型配置---------------
//护理服务类型列表查询
export function serviceTypeList(params) {
  return req.get("/admin/nursing-type/associateList",params);
}
//护理服务类型删除
export function deleteServiceType(params) {
    return req.delete(`/admin/nursing-type/${params}`);
}
//关联保存。同时保存类型和类型所属的服务配置
export function addServiceType(params) {
    return req.post("/admin/nursing-type/associateSave",params);
}
// //护理服务类型更新
// export function updateServiceType(params) {
//   return req.put("/admin/nursing-type",params);
// }

// -----------异常情况处理---------------
//患者服务异常表分页查询
export function queryUnnormalList(params) {
  return req.post("/admin/patient-service-exce/page",params);
}
//关联保存。同时保存类型和类型所属的服务配置
export function handleUnnormal(params) {
  return req.put("/admin/patient-service-exce",params);
}

// -----------服务订单处理-------------------
//护理服务分页查询
export function queryOrderList(params) {
  return req.post("/admin/nursing-service/page",params);
}

//根据parentId获取地区列表
export function getArea(params) {
  return req.get(`/patient/region/${params}/children`);
}

//根据地区查询护士列表
export function getNurseListByDistrict(params) {
  return req.get("/admin/doctor-team-member/getNurseListByDistrict",params);
}

//派单
export function dispatchOrder(params) {
  return req.get("/admin/nursing-service/dispatch",params);
}

//取消派单
export function orderCancelled(params) {
  return req.get("/admin/nursing-service/caseMgrCancelled",params);
}
//获取医院列表
export function findHospitalByKeyWord(params) {
  return req.post("/admin/hospital/findHospitalByKeyWord",params);
}
export function getLabelDatabaseByNameNew(params) {
  return req.post("/admin/label-database/getLabelDatabaseNameByName", params);
}
//搜索内容标签
export function getLabelTag(params) {
  return req.post("/admin/label-database/getContentLabelDatabaseByName", params);
}

//获取渠道机构列表
export function channelHospital(params) {
  return req.post("/admin/org-channel/pageList",params);
}

